import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {
  IconButton,
  TextField,
  Grow,
  FormControl,
  OutlinedInput,
} from "@mui/material";
import { CopyAll } from "@mui/icons-material";
import { useAppDispatch } from "../../../core/redux/hooks";
import copy from "copy-to-clipboard";
import { deleteUser } from "../../../core/redux/features/users/userSlice";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 550,
  bgcolor: "background.paper",
  p: 4,
  height: "230px",
  borderRadius: "5px",
  boxShadow:
    "0px 3px 1px -2px rgba(145, 158, 171, 0.2), 0px 2px 2px 0px rgba(145, 158, 171, 0.14), 0px 1px 5px 0px rgba(145, 158, 171, 0.12)",
};

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 550,
//   bgcolor: "#F9FAFB",
//   boxShadow:
//     "0px 3px 1px -2px rgba(145, 158, 171, 0.2), 0px 2px 2px 0px rgba(145, 158, 171, 0.14), 0px 1px 5px 0px rgba(145, 158, 171, 0.12)",
//   p: 4,
//   // height: "230px",
//   borderRadius: "5px",
// };

export default function DeleteModal(props: {
  userInfo: { name: string; email: string };
}) {
  const [open, setOpen] = React.useState(false);
  const [copiedName, setCopiedName] = React.useState("");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const dispatch = useAppDispatch();

  const handleDelete = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (copiedName === props.userInfo.name) {
      dispatch(deleteUser({ email: props.userInfo.email })).then(() => {
        setOpen(false);
      });
    } else {
      console.log("Wrong Name");
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    e.preventDefault();
    setCopiedName(e.target.value);
  };

  return (
    <>
      <Button onClick={handleOpen} sx={{ fontSize: "14px" }} color="error">
        Delete
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              pt="4px"
            >
              <Box display={"flex"} gap="4px">
                <Grow in={true} {...{ timeout: 800 }}>
                  <Typography fontSize="17px" fontWeight="600">
                    User name: {props.userInfo.name}
                  </Typography>
                </Grow>
                <Grow in={true} {...{ timeout: 800 }}>
                  <Box mt={-1.1}>
                    <IconButton
                      onClick={() => {
                        copy(props.userInfo.name);
                      }}
                    >
                      <CopyAll />
                    </IconButton>
                  </Box>
                </Grow>
              </Box>
              <Box mt={1.9}>
                <form style={FormStyle as any} onSubmit={handleDelete}>
                  <TextField
                    id="company-name-for-confirmation"
                    label="Сopy and paste the company names here"
                    variant="outlined"
                    defaultValue={copiedName}
                    value={copiedName}
                    onChange={handleChange}
                    style={{ width: "430px" }}
                    // onPaste={(event) => {
                    //   // Do not prevent the default unless you need to process the pasted data.
                    //   console.log(
                    //     "Pasted data:",
                    //     event.clipboardData.getData("text")
                    //   );
                    // }}
                    // inputProps={{ onPaste: undefined }}
                    required
                  />

                  <Button
                    sx={{
                      width: "430px",
                      bgcolor: "red",
                      "&:hover": {
                        background: "#f00",
                      },
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Delete
                  </Button>
                </form>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export const FormStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "22px",
};
